module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'osi2iscg',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
